const zod = require('zod');

const envSchema = zod.object({
  NEXT_PUBLIC_ENV: zod.enum(['local', 'dev', 'prod']),
  NEXT_PUBLIC_E2E_URL: zod.string().url(),
  NEXT_PUBLIC_SHOP_CONTENTFUL_SPACE_ID: zod.string(),
  NEXT_PUBLIC_SHOP_CONTENTFUL_ACCESS_TOKEN: zod.string(),
  NEXT_PUBLIC_SHOP_CONTENTFUL_ENVIRONMENT: zod.string(),
  NEXT_PUBLIC_COMMERCE_SERVICE_API: zod.string().url(),
  NEXT_PUBLIC_SEGMENT_API_KEY: zod.string(),
  NEXT_PUBLIC_MSV2_API: zod.string(),
  NEXT_PUBLIC_SMARTY_API_KEY: zod.string(),
  NEXT_PUBLIC_STRIPE_KEY: zod.string(),
  NEXT_PUBLIC_STRIPE_EU_KEY: zod.string(),
  NEXT_PUBLIC_SHOP_SENTRY_DSN: zod.string(),
  NEXT_PUBLIC_COMMIT_SHA: zod.string(),
  NEXT_PUBLIC_AMPLITUDE_API_KEY: zod.string(),
  NEXT_PUBLIC_OKENDO_SUBSCRIBER_ID: zod.string(),
  NEXT_PUBLIC_SHOPIFY_BASE_URL: zod.string(),
  NEXT_PUBLIC_SHOPIFY_ACCESS_TOKEN: zod.string(),
});

const env = envSchema.parse({
  NEXT_PUBLIC_ENV: process.env.NEXT_PUBLIC_ENV,
  NEXT_PUBLIC_E2E_URL: process.env.NEXT_PUBLIC_E2E_URL,
  NEXT_PUBLIC_SHOP_CONTENTFUL_SPACE_ID:
    process.env.NEXT_PUBLIC_SHOP_CONTENTFUL_SPACE_ID,
  NEXT_PUBLIC_SHOP_CONTENTFUL_ACCESS_TOKEN:
    process.env.NEXT_PUBLIC_SHOP_CONTENTFUL_ACCESS_TOKEN,
  NEXT_PUBLIC_SHOP_CONTENTFUL_ENVIRONMENT:
    process.env.NEXT_PUBLIC_SHOP_CONTENTFUL_ENVIRONMENT,
  NEXT_PUBLIC_SEGMENT_API_KEY: process.env.NEXT_PUBLIC_SEGMENT_API_KEY,
  NEXT_PUBLIC_COMMERCE_SERVICE_API:
    process.env.NEXT_PUBLIC_COMMERCE_SERVICE_API,
  NEXT_PUBLIC_MSV2_API: process.env.NEXT_PUBLIC_MSV2_API,
  NEXT_PUBLIC_SMARTY_API_KEY: process.env.NEXT_PUBLIC_SMARTY_API_KEY,
  NEXT_PUBLIC_STRIPE_KEY: process.env.NEXT_PUBLIC_STRIPE_KEY,
  NEXT_PUBLIC_STRIPE_EU_KEY: process.env.NEXT_PUBLIC_STRIPE_EU_KEY,
  NEXT_PUBLIC_SHOP_SENTRY_DSN: process.env.NEXT_PUBLIC_SHOP_SENTRY_DSN,
  NEXT_PUBLIC_COMMIT_SHA: process.env.CIRCLE_SHA1 || '',
  NEXT_PUBLIC_AMPLITUDE_API_KEY: process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY,
  NEXT_PUBLIC_OKENDO_SUBSCRIBER_ID:
    process.env.NEXT_PUBLIC_OKENDO_SUBSCRIBER_ID,
  NEXT_PUBLIC_SHOPIFY_BASE_URL: process.env.NEXT_PUBLIC_SHOPIFY_BASE_URL,
  NEXT_PUBLIC_SHOPIFY_ACCESS_TOKEN:
    process.env.NEXT_PUBLIC_SHOPIFY_ACCESS_TOKEN,
});

module.exports = { env };
